import { createApp } from 'vue'
import App from './App.vue'
import router from './router';  
import flyIn from './directives/flyIn';
import VueLazyload from 'vue-lazyload';




const app = createApp(App);

//app.directive('test', {
//    mounted(el) {
//      el.style.color = 'red'; // 将使用该指令的元素文字变成红色
//    },
//  });

app.directive('fly-in', flyIn);
 

app.use(router).mount('#app');

app.use(VueLazyload, {
    preLoad: 1.3,
    error: 'dist/error.png',
    loading: 'dist/loading.gif',
    attempt: 1
  });


